import React from 'react';
import { useTimeFormatter } from '../../../data/hooks/datetimeHooks';
import styles from './TimeSpan.module.scss';
import { TIME_FORMAT_SPAN } from '../../../data/constants/datetime';

const TimeSpan = (props) => {
    const { className = '', start, end, startClassName = styles.start, endClassName = styles.end, style } = props,
        formatTime = useTimeFormatter(TIME_FORMAT_SPAN),
        formattedStart = formatTime(start),
        formattedEnd = formatTime(end);

    if (end && formattedStart !== formattedEnd) {
        return (
            <div className={[className, styles.TimeSpan].join(' ')}>
                <div className={startClassName} style={style}>
                    {formattedStart}
                </div>
                <div className={styles.separator} />
                <div className={endClassName}>{formattedEnd}</div>
            </div>
        );
    } else {
        return (
            <div className={[className, styles.TimeSpan].join(' ')} style={style}>
                <div className={[styles.start, startClassName].join(' ')}>{formattedStart}</div>
            </div>
        );
    }
};

export default TimeSpan;
